import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanItem } from 'src/features/servicePlanItems/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/:planItemId/activate/';

type MutationFnType = typeof mutationFn;

interface DTO {
    planItemId: string;
}

const mutationFn = ({ planItemId }: DTO): Promise<ServicePlanItem> => {
    return axios.post(formatResourcePath(RESOURCE, { planItemId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useActivateServicePlanItem };
